import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { EventCentreDialogState } from '../event-centre-dialog.state';
import { sortItems } from '../function/sort-items.function';

import { SortItems } from './sort-items.action';

export function sortItemsReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType, SortItems>,
): EventCentreDialogState {
    try {
        const sortedItems = sortItems(
            action.payload.orderBy,
            state.filteredItems,
        );

        return {
            ...state,
            orderBy: action.payload.orderBy,
            filteredItems: sortedItems,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
